<template>
  <el-form
    :model="formData"
    ref="formDelayRef"
    label-width="180px"
    :disabled="disabled"
    :rules="formRules"
  >
    <el-form-item :label="`${$t('原整改期限')}`" prop="rectDeadline">
      <el-date-picker
        disabled
        type="date"
        v-model="formData.rectDeadline"
        style="width: 100%;"
      ></el-date-picker>
    </el-form-item>
    <el-form-item :label="`${$t('申请延期天数')}`" prop="delayDays">
      <el-input-number
        style="width: 30%;"
        size="small"
        :placeholder="`${$t('请输入')}`"
        v-model="formData.delayDays"
        maxlength="5"
        :step="1"
        step-strictly
        :min="1"
      />
      <span class="ml-10px">天</span>
    </el-form-item>
    <el-form-item :label="`${$t('申请原因')}`" prop="reason">
      <el-input
        style="width: 100%;"
        size="small"
        :placeholder="`${$t('请输入')}`"
        v-model="formData.reason"
        type="textarea"
        clearable
        show-word-limit
        maxlength="500"
        :autosize="{ minRows: 2 }"
      />
    </el-form-item>
    <el-form-item :label="`${$t('已采取的临时控制措施')}`" prop="measures">
      <el-input
        style="width: 100%;"
        size="small"
        :placeholder="`${$t('请输入')}`"
        v-model="formData.measures"
        type="textarea"
        clearable
        show-word-limit
        maxlength="500"
        :autosize="{ minRows: 2 }"
      />
    </el-form-item>
    <el-form-item :label="`${$t('申请人')}`" prop="applicantName">
      <el-input
        :placeholder="`${$t('自动获取')}`"
        style="width: 100%;"
        size="small"
        v-model="formData.applicantName"
        disabled
      />
    </el-form-item>
    <el-form-item :label="`${$t('申请时间')}`" prop="applicationTime">
      <el-date-picker
        disabled
        type="datetime"
        v-model="formData.applicationTime"
        :placeholder="`${$t('自动获取')}`"
        style="width: 100%;"
      ></el-date-picker>
    </el-form-item>
  </el-form>
</template>
<script>
export default {
  name: 'violation-delay-command',
  props: {
    disabled: {
      default: false,
      type: Boolean,
    },
    operateType: {
      type: String,
      default: 'create',
    },
    delayData: {
      type: Object,
      default: () => {
        return {}
      },
    },
  },
  computed: {},
  data() {
    return {
      formData: {
        recordId: '',
        delayDays: 2,
        reason: '',
        measures: '',
        rectDeadline: '',
        applicantName: '',
        applicationTime: '',
      },
      formRules: {
        delayDays: [{ required: true, message: this.$t('请输入'), trigger: ['blur', 'change'] }],
        reason: [{ required: true, message: this.$t('请输入'), trigger: ['blur', 'change'] }],
        measures: [{ required: true, message: this.$t('请输入'), trigger: ['blur', 'change'] }],
      },
    }
  },
  mounted() {
    if (this.operateType === 'create') {
      this.formData = { ...this.formData, ...this.delayData }
    }
  },

  methods: {
    async subData() {
      await this.$refs.formDelayRef.validate()
      const params = {
        delayDays: this.formData.delayDays,
        reason: this.formData.reason,
        measures: this.formData.measures,
      }
      this.$emit('subData', params)
    },
    // 详情回显
    detailShow(data) {
      Object.keys(this.formData).forEach((key) => {
        this.formData[key] = data[key]
      })
    },
  },
}
</script>
<style lang="scss" scoped></style>
